import { mapState, mapMutations } from 'vuex'
import axios from 'axios';
import router from '../router'
	
export const commonMixin = {
	data: function () {
		return {
			toggled_row : null,
			payment_statuses: {
				'paid' : 'Pagato',
				'unpaid' : 'Non pagato',
				'pending' : 'In lavorazione',
				'' : '-'
			},
		}
	},
	computed: {
		...mapState([ 'base_url', 'locale', 'mode', 'order', 'order_type' ]),
	},
	methods: {
		...mapMutations([ 'setLoaded', 'setLocale', 'setShopProducts', 'setShopEvents', 'setPermissions', 'setExtraTimePrice', 'setOrder' ]),
		redirectOut(){
			window.location.href = this.base_url;
		},
		restConfig(){
			return { headers : {'X-WP-Nonce' : this.nonce} }
		},
		readableDateTime(datetime_local){
			var dateObject = new Date(datetime_local);
			let y = dateObject.getFullYear();
			let m = (dateObject.getMonth()+1).toString().padStart(2, '0');
			let d = dateObject.getDate().toString().padStart(2, '0');
			
			let h = dateObject.getHours().toString().padStart(2, '0');
			let ms = dateObject.getMinutes().toString().padStart(2, '0');
			
			let date = d+'/'+m+'/'+y;
			let time = h+':'+ms;
			
			return date+' '+time;
		},
		readableDate(date){
			let split = date.split('-');
			split.reverse();
			return split.join('/');
		},
		readableTime(time){
			let split = time.split(':');
			split.splice(2,1);
			return split.join(':');
		},
		readableMinutes(minutes){
			let negative = minutes < 0;
			minutes = Math.abs(minutes);
			let hours = Math.floor(minutes/60);
			let rest = minutes - (hours * 60);
			return (negative?'-':'')+hours+'h '+rest+'m';
		},
		timeDifference(end, start){
			let negative = false;
			let difference = new Date('2024/12/01 '+end) - new Date('2024/12/01 '+start);
			
			if(difference < 0){
				difference *= -1;
				negative = true;
			}
			let hours = Math.floor((difference/1000)/3600);
			let minutes = ((difference/1000) - (hours*3600))/60;
			
			if(negative){
				if(hours != 0){
					hours *= -1;
				}else{
					minutes *= -1;
				}
			} 
			
			return ((hours != 0) ? (hours+'h ') : '')+minutes.toString().padStart(2,0)+'m';
		},
		getAge(date) {
			var today = new Date();
			var birthDate = new Date(date);
			var age = today.getFullYear() - birthDate.getFullYear();
			var m = today.getMonth() - birthDate.getMonth();
			age = age * 12 + m;
			
			var years = Math.floor(age/12);
			var months = age - (12*years);
			
			return years+' ann'+(years==1 ? 'o' : 'i')+' e '+months+' mes'+(months==1 ? 'e' : 'i');
		},
		getAgeMonths(date) {
			var today = new Date();
			var birthDate = new Date(date);
			var age = today.getFullYear() - birthDate.getFullYear();
			var m = today.getMonth() - birthDate.getMonth();
			
			return age * 12 + m;
		},
		getAgeRange(age) {	
			switch(true){
				case age < 36: return 0;
				case age < 72: return 1;
				case age < 120: return 2;
				default: return 3;
			}
		},
		getParentsStatus(parent){
			let first_signed = parent.first_parent.document_signed,
				second_signed = parent.second_parent.document_signed,
				second_can_sign = !parent.parent_2_disclaimer;
			
			if(!second_can_sign && !first_signed) return 'red';
			if(second_can_sign){
				if(!first_signed && !second_signed) return 'red';
				if(first_signed !==second_signed) return 'yellow';
			}
			return 'green';
		},
		dateToInput(date_object){
			let y = date_object.getFullYear();
			let m = (date_object.getMonth()+1).toString().padStart(2, '0');
			let d = date_object.getDate().toString().padStart(2, '0');
			
			return y+'-'+m+'-'+d;
		},
		timeToObject(time){
			let time_split = time.split(':');
			return {
				h : parseInt(time_split[0]),
				m : parseInt(time_split[1])
			};
		},
		objectToTime(object){
			return object.h.toString().padStart(2, '0')+':'+object.m.toString().padStart(2, '0')
		},
		toggleRow(row){
			if(this.toggled_row == row){
				this.toggled_row = null;
			}else{
				this.toggled_row = row;
			}
		},
		getGeneralData(){
			var config = this.restConfig();
			
			axios.get( this.base_url+'/wp-json/qzr-api/general-data', config )
				.then(response => {
					this.setLoaded();
					this.setLocale(response.data.locale);
					this.setShopProducts(response.data.products);
					this.setPermissions(response.data.permissions);
					this.setExtraTimePrice(response.data.extra);
					if(response.data.events){
						this.setShopEvents(response.data.events);
					}
					this.loading = false;
					
					//In assenza di figli rimando alla creazione
					if(this.mode == 'user' && response.data.children_count == 0){
						router.push('/info#child');
					}
				});
		},
		getAppointments(event){
			let appointments = [];
			
			if(event.dates){
				event.dates.forEach( date => {
					if(date.date_start){
						let dateStartObject = new Date(date.date_start);
						let appointment = false;
							
						if( !date.date_end || date.date_end == date.date_start){
							//Appuntamento singolo 
							appointment = this.getAppoinment(dateStartObject, date);
							if(appointment.location=='') appointment.location = event.location;
							appointments.push(appointment);
						}else{
							//Appuntamento ripetuto
							let dateEndObject = new Date(date.date_end);
							
							for (var d = dateStartObject; d <= dateEndObject; d.setDate(d.getDate() + 1)) {
								if(date.selected_days.indexOf(d.getDay()) !== -1){
									appointment = this.getAppoinment(d, date);
									if(appointment.location=='') appointment.location = event.location;
									appointments.push(appointment);
								}
							}
						}
					}
				});
			}
			
			appointments.sort( (a,b) => {
				if(a.date == b.date){
					return a.time_start > b.time_start;
				}
				return a.date > b.date;
			});
		
			return appointments;
		},
		getAppoinment(day_object, date){
			let day = this.dateToInput(day_object);
			return {
				title : date.title ? date.title : '',
				date : day,
				time_start : date.time_start ? date.time_start : null,
				time_end : date.time_end ? date.time_end : null,
				location : date.location ? date.location : '',
			}
		},
		downloadAsCsv(csvContent, fileName = 'data.csv') {
			const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
			const url = URL.createObjectURL(blob);
			
			const anchor = document.createElement('a');
			anchor.href = url;
			anchor.download = fileName;
			anchor.style.display = 'none';
			document.body.appendChild(anchor);
			anchor.click();
			document.body.removeChild(anchor);
			
			console.log(anchor)
			URL.revokeObjectURL(url);
		},
	}
}
